// ContextMenu.jsx
import { useEffect, useRef } from "react"

export default function ContextMenu({ x, y, isOpen, onClose, items }) {
    const menuRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose()
            }
        }

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside)
            document.addEventListener("scroll", onClose)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
            document.removeEventListener("scroll", onClose)
        }
    }, [isOpen, onClose])

    if (!isOpen) return null

    const style = {
        position: "fixed",
        top: y,
        left: x,
        zIndex: 1000,
    }

    return (
        <div
            ref={menuRef}
            style={style}
            className="bg-gray-800 border border-gray-700 rounded-lg shadow-xl min-w-[180px] py-2"
        >
            {items.map((item, index) =>
                item.element ? (
                    <span key={index}>{item.element}</span>
                ) : (
                    <button
                        key={index}
                        onClick={(e) => {
                            e.stopPropagation()
                            item.onClick()
                            onClose()
                        }}
                        className="w-full text-right px-4 py-2 hover:bg-gray-700 transition-colors flex items-center gap-2 text-white"
                    >
                        {item.icon && <span className="text-lg">{item.icon}</span>}
                        <span>{item.label}</span>
                    </button>
                )
            )}
        </div>
    )
}
